
import mutations from '../../general/mutations';
import currentMutations from './mutations';
import { DataService } from '../../../../src/config/dataService/dataService';


const state = () => ({
    list: [],
    currentPagesBanner: {},
    loading: false,
    message: '',
});
// declare actions
const actions = {

    async getAllPagesBanners({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetPagesBanners`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_PAGE_BANNERS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async addPagesBanner({ commit }, pagesBanner) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/AddPagesBanner`, pagesBanner);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async editPagesBanner({ commit }, pagesBanner) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/UpdatePageBanner`, pagesBanner);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async changePagesBannerStatus({ commit },pagesBannerId) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/ChangePagesBannerStatus`,{},{
                id:pagesBannerId
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async setPagesBanners({ commit }, pagesBanners) {
        try {
            await commit('SET_PAGE_BANNERS', pagesBanners);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentPagesBannerToView({ commit },pagesBanner) {
        await commit('axiosStart');
        await commit('SET_CURRENT_PAGE_BANNER',pagesBanner);
        await commit('axiosSuccess');
        return true
    },
    
    // Section Header
    async getAllSectionsHeaders({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetSectionsHeaders`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_SECTION_HEADERS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async addSectionsHeader({ commit }, sectionsHeader) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/AddSectionsHeader`, sectionsHeader);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token
    
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async editSectionsHeader({ commit }, sectionsHeader) {
    
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/UpdateSectionHeader`, sectionsHeader);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token
    
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async changeSectionsHeaderStatus({ commit },sectionsHeaderId) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/ChangeSectionsHeaderStatus`,{},{
                id:sectionsHeaderId
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }
    
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async setSectionsHeaders({ commit }, sectionsHeaders) {
        try {
            await commit('SET_SECTION_HEADERS', sectionsHeaders);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentSectionsHeaderToView({ commit },sectionsHeader) {
        await commit('axiosStart');
        await commit('SET_CURRENT_SECTION_HEADERS',sectionsHeader);
        await commit('axiosSuccess');
        return true
    },
    // Footer Photos
    async getAllFooterPhotos({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetAllFooterPhotos`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_FOOTER_PHOTOS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async editFooterPhoto({ commit }, footerPhoto) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/UpdateFooterPhoto`, footerPhoto);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async setFooterPhotos({ commit }, footerPhotos) {
        try {
            await commit('SET_FOOTER_PHOTOS', footerPhotos);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async storeCurrentFooterPhotoToView({ commit },footerPhoto) {
        await commit('axiosStart');
        await commit('SET_CURRENT_FOOTER_PHOTOS',footerPhoto);
        await commit('axiosSuccess');
        return true
    },
    // Logos
    async getAllLogos({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetAllLogos`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_LOGOS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async editLogo({ commit }, Logo) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/UpdateLogo`, Logo);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async setLogos({ commit }, Logos) {
        try {
            await commit('SET_LOGOS', Logos);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async storeCurrentLogoToView({ commit },Logo) {
        await commit('axiosStart');
        await commit('SET_CURRENT_LOGO',Logo);
        await commit('axiosSuccess');
        return true
    },
    // FooterParagraphs
    async getFooterParagraph({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetFooterParagraph`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_FOOTER_PARAGRAPHS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async updateFooterParagraph({ commit }, FooterParagraph) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/UpdateFooterParagraph`, FooterParagraph);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async setFooterParagraphs({ commit }, FooterParagraphs) {
        try {
            await commit('SET_FOOTER_PARAGRAPHS', FooterParagraphs);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async storeCurrentFooterParagraphToView({ commit },FooterParagraph) {
        await commit('axiosStart');
        await commit('SET_CURRENT_FOOTER_PARAGRAPH',FooterParagraph);
        await commit('axiosSuccess');
        return true
    },

    // Footer Branches
    async getAllFooterBranches({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetBranches`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_FOOTER_BRANCHES', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async deleteFooterBranche({ commit }, value) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/DeleteBranch`,{},{
                id:value.id
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async addFooterBranche({ commit }, footerBranche) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/AddBranch`, footerBranche);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },



    async setFooterBranches({ commit }, footerBranches) {
        try {
            await commit('SET_FOOTER_BRANCHES', footerBranches);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async storeCurrentFooterBrancheToView({ commit },footerBranche) {
        await commit('axiosStart');
        await commit('SET_CURRENT_FOOTER_BRANCHES',footerBranche);
        await commit('axiosSuccess');
        return true
    },
    // FooterSocials
    async getFooterSocial({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetSocialMedia`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_FOOTER_SOCIALS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async addFooterSocial({ commit }, FooterSocial) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/addSocialMedia`, FooterSocial);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateFooterSocial({ commit }, FooterSocial) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/UpdateSocialMedia`, FooterSocial);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async deleteSocial({ commit }, value) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/DeleteSocialMedia`,{},{
                id:value.id
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async setFooterSocials({ commit }, FooterSocials) {
        try {
            await commit('SET_FOOTER_SOCIALS', FooterSocials);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async storeCurrentFooterSocialToView({ commit },FooterSocial) {
        await commit('axiosStart');
        await commit('SET_CURRENT_FOOTER_SOCIAL',FooterSocial);
        await commit('axiosSuccess');
        return true
    },
    // FooterContacts
    async getFooterContact({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetContactMethods`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_FOOTER_CONTACTS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async addFooterContact({ commit }, FooterContact) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/addContactMethod`, FooterContact);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateFooterContact({ commit }, FooterContact) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/UpdateContactMethod`, FooterContact);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async deleteContact({ commit }, value) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/DeleteContactMethod`,{},{
                id:value.id
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async setFooterContacts({ commit }, FooterContacts) {
        try {
            await commit('SET_FOOTER_CONTACTS', FooterContacts);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async storeCurrentFooterContactToView({ commit },FooterContact) {
        await commit('axiosStart');
        await commit('SET_CURRENT_FOOTER_CONTACT',FooterContact);
        await commit('axiosSuccess');
        return true
    },
    // SEOs
    async getAllSEOs({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Settings/GetSEOKeywords`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_SEOS', response.data.data);
                return response.data.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async editSEO({ commit }, SEO) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Settings/UpdateSEOKeywords`, SEO);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async setSEOs({ commit }, SEOs) {
        try {
            await commit('SET_SEOS', SEOs);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async storeCurrentSEOToView({ commit },SEO) {
        await commit('axiosStart');
        await commit('SET_CURRENT_SEO',SEO);
        await commit('axiosSuccess');
        return true
    },

};

export default {
    namespaced: false,
    state,
    actions,
    mutations: { ...currentMutations, ...mutations }
};
